import { initHeader } from './header';
import { initHome } from './home';
import { initHeroSlider } from './hero-slider';
import { initSearch } from './search';
import { initCategoryTabs } from './category-tabs';
import { initTestimonials } from './testimonials';
import { initCategoryPage } from './category-page';
import { initShopPage } from './shop-page';
import { initContactButtons } from './contact-buttons';
import { initProductPage } from './product-page';
import { initReferencesPage } from './references';
import { initContactPage } from './contact-page';
import { initAboutPage } from './about-page';
import '../scss/main.scss';
document.addEventListener('DOMContentLoaded', () => {
    initHeader();
    initHome();
    initHeroSlider();
    initSearch();
    initCategoryTabs();
    initTestimonials();
    initCategoryPage();
    initShopPage();
    initContactButtons();
    initProductPage();
    initReferencesPage();
    initContactPage();
    initAboutPage();
});
